import { Text, defaultHover, Colors } from '@amelio/ui-library';

import type { UserCardProps } from './types';
import type { CSSProperties } from 'react';

/** Reusable UserCard component */
export const UserCard = ({
    className,
    compact = false,
    alt,
    name,
    avatar,
    description,
    size = 'small',
    nameWeight = 'semibold',
    nameClassName = '',
    descriptionClassName = 'text-caption',
    backgroundColor,
    textColor = Colors.BASE,
    descriptionTextColor = Colors.BASE,
    borderColor,
    borderSize = '',
    interactive = false,
    onClick,
}: UserCardProps) => {
    const cursorClass = interactive ? defaultHover : '';

    const borderClass = `${borderSize} ${borderColor} rounded-md`;

    const baseClasses = `flex items-center justify-start ${compact ? 'gap-2 py-2 px-0' : 'gap-4 py-2 px-4'} ${borderClass} ${cursorClass} ${backgroundColor} ${className ?? ''}`;

    const inlineStyles: CSSProperties = {
        ...(backgroundColor && { backgroundColor }),
        ...(borderColor && { borderColor }),
    };

    return (
        <div
            className={baseClasses.trim()}
            style={inlineStyles}
            onClick={onClick}
            role={onClick ? 'button' : undefined}
            aria-label={alt}
        >
            <div className={'shrink-0'}>{avatar}</div>

            <div className={'flex min-w-0 flex-1 flex-col gap-1'}>
                <Text
                    color={textColor}
                    weight={nameWeight}
                    size={size}
                    className={`min-w-0 leading-tight break-words whitespace-normal ${nameClassName}`}
                >
                    {name}
                </Text>

                <>
                    {typeof description === 'string' ? (
                        <Text
                            weight={'regular'}
                            color={descriptionTextColor}
                            size={size}
                            className={descriptionClassName}
                        >
                            {description}
                        </Text>
                    ) : (
                        description
                    )}
                </>
            </div>
        </div>
    );
};
